import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PowerStateModule } from 'ngx-zcs-components';

import { FlowChartComponent } from './flow-chart.component';
import { WeatherCardModule } from '../weather-card/weather-card.module';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    FlowChartComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    PowerStateModule,
    WeatherCardModule,
  ],
  exports: [
    FlowChartComponent,
  ],
})
export class FlowChartModule { }
